import groq from 'groq';

/* INFO: Grabs the first variant of a product if one is not selected in CMS. */
export const COALESCING_PRODUCT_VARIANT = groq`
  "variant": coalesce(variant -> { "gid": store.gid },
                      product -> { "gid": store.variants[0] -> store.gid })
`;
